export const configSubRoute = [
  {
    path: "/category-management",
    name: "Category Management",
    layout: "/admin",
    isSidebar: true,
    redirect: false,
    isSubRoute: true,
    configName: "Category Management",
  },
  {
    path: "/status-&-mapping-management",
    name: "Status & Mapping Management",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "Status & Mapping Management",
  },

  {
    path: "/configuration-employee-creation",
    name: "Employee Creation",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "Employee Creation",
  },
  {
    path: "/configuration-control-panel",
    name: "Control Panel",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "Control Panel",
  },

  {
    path: "/configuration-step-assignee",
    name: "Step Assignee",
    layout: "/admin",
    isSidebar: true,
    redirect: true,
    isSubRoute: true,
    configName: "Step Assignee",
  },
];


export const subRouteMapping = (subRouteArr, secName) => {
  return subRouteArr.filter((ele) => ele?.collapse == true && ele?.configName == secName)[0]?.views;
}
